<template>
  <div>
    <div class="mt10 text-center">
      <el-button @click="handleLast">上一步</el-button>
      <el-button type="primary" @click="handleSumbit">
        确定无误，我要提交
      </el-button>
    </div>

    <div class="mt20"><panel ref="Panel"></panel></div>
  </div>
</template>

<script>
import Panel from '../reviews/components/Panel.vue';

import { flowSubmit } from '@/api/position/gains/opers/flow.js';

export default {
  components: {
    Panel
  },
  methods: {
    handleLast() {
      this.$router.push(
        `/position/gains/${this.$route.params.gainEid}/mavin/seled`
      );
    },
    handleSumbit() {
      this.loading = true;
      this.$confirm('您是否要提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        flowSubmit(this.$route.params.gainEid)
          .then(() => {
            this.msgSuccess('提交成功！', function () {
              window.close();
            });
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  },
  created() {
    this.$emit('loaded', 6);
  }
};
</script>

<style scoped>
.subTitle li {
  text-align: left;
  line-height: 35px;
}
</style>
